var _excluded = ["analyticsName", "cardStyle"],
    _excluded2 = ["variant", "clickable", "analyticsName"];

function cov_gid0f43ak() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx";
  var hash = "1b0706ac7cc807d857d1a6d0a127ba87cb86edae";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx",
    statementMap: {
      "0": {
        start: {
          line: 34,
          column: 81
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "1": {
        start: {
          line: 39,
          column: 29
        },
        end: {
          line: 39,
          column: 51
        }
      },
      "2": {
        start: {
          line: 40,
          column: 30
        },
        end: {
          line: 43,
          column: 4
        }
      },
      "3": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 49,
          column: 30
        }
      },
      "4": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      "5": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 71
        }
      },
      "6": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 57,
          column: 4
        }
      },
      "7": {
        start: {
          line: 60,
          column: 41
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "8": {
        start: {
          line: 61,
          column: 16
        },
        end: {
          line: 61,
          column: 72
        }
      },
      "9": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 64,
          column: 3
        }
      },
      "10": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 91
        }
      },
      "11": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 71,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 34,
            column: 81
          },
          end: {
            line: 34,
            column: 82
          }
        },
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 38
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        },
        loc: {
          start: {
            line: 44,
            column: 18
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 60,
            column: 41
          },
          end: {
            line: 60,
            column: 42
          }
        },
        loc: {
          start: {
            line: 60,
            column: 94
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 60
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 45
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 62
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1b0706ac7cc807d857d1a6d0a127ba87cb86edae"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gid0f43ak = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_gid0f43ak();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { useStyleConfig } from '../../system/utils';
import Flex from '../Flex';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { useInView } from 'react-intersection-observer';
/**
 * NOTE ABOUT METRIC TRACKING:
 * Card is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{cardName}
 *  2) card enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.card_view_event for card impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */

cov_gid0f43ak().s[0]++;

var CardWithTracking = function CardWithTracking(_ref) {
  var analyticsName = _ref.analyticsName,
      cardStyle = _ref.cardStyle,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_gid0f43ak().f[0]++;

  var _ref2 = (cov_gid0f43ak().s[1]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent;

  var _ref3 = (cov_gid0f43ak().s[2]++, useInView({
    threshold: 1,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  cov_gid0f43ak().s[3]++;
  useEffect(function () {
    cov_gid0f43ak().f[1]++;
    cov_gid0f43ak().s[4]++;

    if (inView) {
      cov_gid0f43ak().b[0][0]++;
      cov_gid0f43ak().s[5]++;
      trackUserEvent({
        cardViewEvent: {
          targetName: analyticsName
        }
      });
    } else {
      cov_gid0f43ak().b[0][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]);
  cov_gid0f43ak().s[6]++;
  return /*#__PURE__*/React.createElement(Flex // __css has a lower priority than sx
  , _extends({
    ref: inViewRef,
    __css: cardStyle
  }, props));
};

cov_gid0f43ak().s[7]++;
export var Card = function Card(_ref5) {
  var variant = _ref5.variant,
      clickable = _ref5.clickable,
      analyticsName = _ref5.analyticsName,
      props = _objectWithoutProperties(_ref5, _excluded2);

  cov_gid0f43ak().f[2]++;
  var style = (cov_gid0f43ak().s[8]++, useStyleConfig('Card', _objectSpread({
    variant: variant,
    clickable: clickable
  }, props)));
  cov_gid0f43ak().s[9]++;

  if (analyticsName) {
    cov_gid0f43ak().b[1][0]++;
    cov_gid0f43ak().s[10]++;
    return /*#__PURE__*/React.createElement(CardWithTracking, _extends({
      cardStyle: style,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_gid0f43ak().b[1][1]++;
  }

  cov_gid0f43ak().s[11]++;
  return /*#__PURE__*/React.createElement(Flex // __css has a lower priority than sx
  , _extends({
    __css: style
  }, props));
};
export default Card;